const Kategoriya2233 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 2-chorak<br />
                Mavzu: So‘zning ma’nolarini o‘rganamiz <br />
“Sal murakkab” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Juftlikda ishlang. Iboralarni qatnashtirib gaplar tuzing.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘z ma’nolari haqidagi bilimlarini mustahkamlash.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            <p className="text-break">Dodini bermoq - __________________________________________________</p>
            <p className="text-break">Burni ko‘tarilmoq - ________________________________________________</p>
            <p><b>2-mashq. Juftlikda ishlang. Aralash berilgan so‘zlarni o‘qing va qarama-qarshi ma’noli so‘zlarni yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning leksik ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3 daqiqa.</p>
            <p>Bahor, yoz, tun, oz, kun, ko‘p, oq, qizil, qora, farishta, dono, o‘qituvchi, nodon, kaltafahm, chiroyli, go‘zal, xunuk.</p>
            <p><b> 3-mashq. FDM usuli asosida ma’nodosh so‘zlar haqida fikr yuriting.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning leksik ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-center">Ho‘l, nam, shalabbo…</p>
            <p className="text-break">Fikr - ___________________________________________________________</p>
            <p className="text-break">Dalil - _________________________________________________________</p>
            <p className="text-break">Misol - _______________________________________________________</p>
        </div>
    )
}
export default Kategoriya2233;